import React from 'react';
import { __ } from '@wordpress/i18n';
import Button3d from '../../../../../../components/ButtonWrapper/components/Button3d';

const NavigationButtons = ({ myStudioLeftPanel, handleChangePanelState }) => {
    return (
        <div className="timelineEditorAuxControls__buttons">
            <Button3d
                changeFn={handleChangePanelState}
                name="video"
                checked={myStudioLeftPanel === 'video'}>
                {__('Video', 'soundbetween')}
            </Button3d>
            <Button3d
                changeFn={handleChangePanelState}
                name="music"
                checked={myStudioLeftPanel === 'music'}>
                {__('Music', 'soundbetween')}
            </Button3d>
            <Button3d
                changeFn={handleChangePanelState}
                name="audio"
                checked={myStudioLeftPanel === 'audio'}>
                {__('Audio', 'soundbetween')}
            </Button3d>
            <Button3d
                changeFn={handleChangePanelState}
                name="rec"
                checked={myStudioLeftPanel === 'rec'}>
                {__('REC Session', 'soundbetween')}
            </Button3d>
        </div>
    );
};

export default NavigationButtons;
